import { useState } from 'react';
import { useActions } from '../../../hooks';

import { Card } from '@pella/sash-framework';
import { RequestModal } from '..';

import * as classes from './ActionCards.module.css';

/**
 * Action Cards molecule
 */
export const ActionCards = () => {
  const { data: actions } = useActions({ active: true });

  const [selectedAction, setSelectedAction] = useState(
    /**@type {Pella.ProductionRequestAPI.Action|undefined} */ (undefined),
  );

  /** Close request modal */
  const closeRequestModal = () => setSelectedAction(undefined);

  /**
   * Handle action card click
   * @param {Pella.ProductionRequestAPI.Action} action
   */
  const actionClick = (action) => {
    setSelectedAction(action);
  };

  return (
    <div className={classes.container}>
      {actions?.map((action) => (
        <button
          key={action.id}
          type='button'
          data-testid={`action-card-${action.id}`}
          onClick={() => actionClick(action)}
        >
          <Card className={classes.card}>
            <p>{action.description}</p>
            <p>{action.message}</p>
          </Card>
        </button>
      ))}
      {selectedAction && (
        <RequestModal open={Boolean(selectedAction)} close={closeRequestModal} action={selectedAction} />
      )}
    </div>
  );
};
